export default __webpack_public_path__ + "static/media/loopmania.1bf2506c.png";